var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:this.$store.state.auth.link ? this.$store.state.auth.link.id : -1,staticClass:"flex flex-col min-h-screen font-display",attrs:{"id":"app"}},[_c('vue-progress-bar'),(
              this.$store.getters.isAuthenticated &&
                  this.$store.getters.isUserLoaded
          )?_c('AuthenticatedDashboard'):_c('router-view',{staticClass:"flex-grow"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }